<template>
  <div class="wrap2">
    <div class="row align-center">
      <div class="small-11 medium-10 large-9 columns">
        <div class="row">
          <div class="small-12 small-centered medium-12 medium-centered large-6 columns">
            <p class="texto1">
              {{ $t('UMA_LANG_SASUMA_HOMEINTRO') }}
            </p>
          </div>
          <div class="small-12 small-centered medium-12 medium-centered large-6 columns">
            <p class="texto2">
              {{ $t('UMA_LANG_SASUMA_HOMEINTRO2') }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-center">
      <div class="small-12 small-centered medium-10 medium-centered large-9 columns sasuma_video">
        <iframe width="100%" height="315"
          src="https://www.youtube.com/embed/WmsSMsI8xX0"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media;
              gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup () {
    

    return {}
  }
}
</script>

<style lang="scss" scoped>
.row{
  max-width: 100%;
}

.row .row{
  margin-left: 0;
  margin-right: 0;
}

.wrap2 {
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  margin: 0;
}

.texto1 {
  font-family: "PT Sans Italic";
  font-size: 25px;
  line-height: 1.99;
  padding-top: 90px;
  padding-bottom: 25px;
  color: #333333;
  padding-right: 10px;
  padding-left: 3%;
}

.texto2 {
  font-family: 'PT Sans';
  color: #333333;
  line-height: 2.5;
  font-size: 17px;
  margin-bottom: 90px;
  margin-top: 90px;
}

/*#endregion*/

.sasuma_video {
  margin-bottom: 50px;
}

@media (max-width: 1023px) {
  .texto2 {
    margin-top: 0px;
  }

  .texto1 {
    padding-left: 0px;
    padding-top: 60px;
  }
}


@media (max-width: 767px) {
  .texto1 {
    font-size: 20px;
    line-height: 1.69;
    padding-top: 50px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .texto2 {
    font-size: 14px;
    line-height: 2;
    font-family: 'PT Sans';
    color: #333333;
    margin-top: 0px;
    margin-bottom: 45px;
  }
}
</style>